import React from "react";
import { styled } from "@mui/material/styles";
import { Avatar, Menu, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";
import "../Header/Header.css";

const StyledAvatar = styled(Avatar)({
  height: "40px",
  width: "40px",
  cursor: "pointer",
});

function Header({ onSignOut }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const userName = sessionStorage.getItem("userName") || "";

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <div style={styles.headerContainer}>
      {/* Center: Brand */}
      <div style={styles.centerHeading}>
        <Link to="/" style={styles.link}>
          <h1 style={styles.heading}>
            <span style={styles.blue}>TopLine</span>{" "}
            <span style={styles.purple}>SpeedStack</span>
          </h1>
        </Link>
      </div>

      {/* Right: Avatar & username */}
      <div style={styles.right}>
        <span style={styles.userName}>{userName}</span>
        <StyledAvatar
          sx={{ backgroundColor: "#006E74" }}
          onClick={handleAvatarClick}
          src="/broken-image.jpg"
        />
      </div>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem>Profile</MenuItem>
        <MenuItem>Settings</MenuItem>
        <MenuItem onClick={onSignOut}>Logout</MenuItem>
      </Menu>
    </div>
  );
}

const styles = {
  headerContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "1rem 2rem",
    borderBottom: "1px solid #e2e8f0",
    backgroundColor: "#fff",
    height: "80px",
  },
  centerHeading: {
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    textAlign: "center",
  },
  heading: {
    fontWeight: 700,
    fontSize: "28px",
    fontFamily: "Ubuntu, sans-serif",
    margin: 0,
  },
  blue: {
    color: "#2563eb",
  },
  purple: {
    color: "#9333ea",
  },
  right: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  userName: {
    color: "#006E74",
    fontFamily: "Ubuntu",
  },
  link: {
    textDecoration: "none",
  },
};

export default Header;
